<div class="modal-top-bar">
    <h2>Node diagnosis anomaly</h2>
</div>
<div class="modal-content">
    <div class="ndi-container">
        <div class="ndi-records-container">
            <h5>Records</h5>
            <div *ngFor="let diagnosis of diagnosisDataDTO">
                <div>
                    <h3>{{ diagnosis.source }}</h3>
                    <div class="ndi-record" *ngFor="let record of diagnosis.records; let last = last">
                        <span (click)="selectRecord(record)">{{record.timestamp}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="ndi-selectedrecord-placeholder" *ngIf="selectedRecord == null">
            <span>Select a record</span>
        </div>
        <div class="ndi-record-container" *ngIf="selectedRecord != null">
            <h5>
                Record: {{ selectedRecord.timestamp | date: 'dd/MM/yyyy HH:mm:ss' }}
            </h5>
            <div>
                <h6>Variables</h6>
                <ul>
                    <li *ngFor="let variable of selectedRecord.variables">
                        <strong>{{ variable.name }}: </strong>
                        <span>{{ variable.values.join(', ') }}</span>
                    </li>
                </ul>
            </div>
            <div class="mt-2">
                <h6>Features</h6>
                <ul>
                    <li *ngFor="let feature of selectedRecord.features">{{ feature }}</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="modal-bottom-bar">
    <button class="button mini wide" (click)="cancel()">Close</button>
</div>